import { render } from "./NavHeader.vue?vue&type=template&id=531dfa9c&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import "./NavHeader.vue?vue&type=style&index=0&id=531dfa9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531dfa9c"]])

export default __exports__